import { oFlowerPot } from "./oFlowerPot.js";

export var oCFlowerPot = InheritO(oFlowerPot, {
	EName: "oCFlowerPot",
	PicArr: ["images/Card/Plants/CFlowerPot.webp", "images/Plants/FlowerPot/C/0.gif", "images/Plants/FlowerPot/C/CFlowerPot.gif"],
	Produce: "Allows plants to be planted on tiled terrain.</font></p>Celadon flower pot, no introduction needed",
});
